import dayjs from "utils/dayjs"

import { Guid } from "@/types"
import { Currency, Purpose } from "config/constants"
import { IPostCalculationAdjustmentDto } from "./CalculationAdjustment"
import { InvoicePositionDistributionRule } from "./TenantInvoicePosition"

export enum CalculationParamsValidation {
    valid = "valid",
    noOverheadCostsSaleGeneral = "noOverheadCostsSaleGeneral",
    noOverheadCostsSaleIndividual = "noOverheadCostsSaleIndividual",
    noOverheadCostsRentalGeneral = "noOverheadCostsRentalGeneral",
    noOverheadCostsRentalIndividual = "noOverheadCostsRentalIndividual",

    noReferenceValuesForAllAssets = "noReferenceValuesForAllAssets",
    noReferenceValuesForSomeAssets = "noReferenceValuesForSomeAssets",

}

export interface IUpdateCalculationResultRespDto {
    paramsValidationStatus: CalculationParamsValidation[]
    calculatedAmount: number
    returnPercentage: number
    reservationDuration?: string
}


export interface IUpdateCalculationResultDto {
    assetIds: Guid[]
}

export interface IUpdateCalculationResultSaleDto {
    purpose: Purpose.sale
    salePrice: number
    language: string | null
    customerCurrency: Currency
}
export interface IUpdateOfferCalculationResultSaleDto {
    totalPrice: number
    startDate: string
    assetIds: Guid[]
    adjustments: IPostCalculationAdjustmentDto[]
    invoicePositions: {
        distributionRule: InvoicePositionDistributionRule
        amount: number
    }[]
    offerNumber?: string
    customerName?: string
    customerNumber?: string
    customerCurrency: Currency
    language: string | null
}

export default class CalculationResult {
    paramsValidationStatus: CalculationParamsValidation[]
    calculatedAmount: number
    returnPercentage: number
    reservationDuration?: ReturnType<typeof dayjs.duration>

    constructor(dto: IUpdateCalculationResultRespDto) {
        this.paramsValidationStatus = dto.paramsValidationStatus
        this.calculatedAmount = dto.calculatedAmount
        this.returnPercentage = dto.returnPercentage

        const reservationDuration = dto.reservationDuration ? dayjs.duration(dto.reservationDuration) : undefined
        // dayjs Duration has no isValid(); an unparseable input yields NaN ms
        if (reservationDuration && !isNaN(reservationDuration.asMilliseconds())) {
            this.reservationDuration = reservationDuration
        }
    }
}
